import { useState } from 'react';

export interface UseTelehealthProps {
  initialTelehealth?: boolean;
}

export interface UseTelehealthReturn {
  telehealth: boolean;
  setTelehealth: (value: boolean) => void;
  handleTelehealthChange: (checked: boolean) => void;
}

/**
 * Hook to manage telehealth state for appointments
 */
export const useTelehealth = ({
  initialTelehealth = false,
}: UseTelehealthProps = {}): UseTelehealthReturn => {
  const [telehealth, setTelehealth] = useState(initialTelehealth);

  const handleTelehealthChange = (checked: boolean) => {
    setTelehealth(checked);
  };

  return {
    telehealth,
    setTelehealth,
    handleTelehealthChange,
  };
};
